import apiCall from '../index'

const apiService = '/gsencuesta/api/v1/tablero_dappsa'

const service = {
  findIndicador1(params) {
    const query = `?idEncuesta=${params.idEncuesta}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(`${apiService}/indicador${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findIndicador2(params) {
    const query = `?idEncuesta=${params.idEncuesta}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(`${apiService}/indicador_detalle${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findIndicadorFicha(params) {
    const query = `?idEncuesta=${params.idEncuesta}&tipoCondicion=${params.tipoCondicion}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(`${apiService}/fichas${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
